import { ACTION_TYPES } from '../../utils/Constants';

const AppointmentReducer = (
    state = {
        studentDetails: {},
    },
    action = {}
) => {
    switch (action.type) {
        case ACTION_TYPES.PHYSICIAN.GET_STUDENT_LIST:
            state = {
                ...state,
                studentDetails: action.payload,
            };
            break;
        default:
            break;
    }
    return state;
};
export default AppointmentReducer;
